import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import styles from "./Home.module.scss";

// components
import Row from "./Row";
import Drawer from "../components/Drawer";

// data
// import { dashboard } from "src/utils/data";
import { sortSourceList } from "src/utils/helpers";

// api
import { getTableData } from "../api";

const Home = () => {
  const [data, setData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [sourceData, setSourceData] = useState(null);

  useEffect(() => {
    getTableData()
      .then((res) => {
        if (res.data.Status) {
          setData(sortSourceList(res.data.Results));
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  const handleClick = (_data) => {
    setSourceData(_data);
    setIsOpen(true);
  };

  if (!data) {
    return <div>Loading</div>;
  }

  console.log(data);

  return (
    <div>
      <div className={styles.home__wrapper}>
        <div className={`${styles.row} ${styles.head}`}>
          {/* <span className={`${styles.text_left}`}>Compelete</span> */}
          <span className={`${styles.text_left} ${styles.pl_md}`}>Source</span>
          <span>IsAffliate</span>
          <span>DataIssues</span>
          <span>TimeSinceLastSuccessScraping</span>
          <span>LastRunStatusScraping</span>
          <span>TimeSinceLastSuccessProcessing</span>
          <span>LastRunStatusProcessing</span>
          <span>NoOfRecordsScraping</span>
          <span>NoOfRecordsProcessing</span>
          <span>%ChangeInRecordsAfterProcessing</span>
          <span>LogDate</span>
        </div>
        {/* {sortSourceList(dashboard).map((item, i) => (
        <Row key={i} data={item} index={i} />
      ))} */}
        {data.map((item, i) => (
          <Row key={i} data={item} index={i} handleClick={handleClick} />
        ))}
      </div>
      <Drawer data={sourceData} isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default Home;
